import { Component, OnInit, Input, Optional, Inject } from "@angular/core";
import { DialogService, HelperService, LanguageService } from "src/app/services";
import { ChainMaintenanceService } from "../chain-maintenance.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { environment } from "src/environments/environment";
import { MediaObserver } from "@angular/flex-layout";
import { finalize } from "rxjs/operators";
import * as _ from "lodash";

@Component({
  selector: 'esc-chain-maintenance-handling-fee-modal',
  templateUrl: './chain-maintenance-handling-fee-modal.component.html',
  styleUrls: ['./chain-maintenance-handling-fee-modal.component.scss']
})
export class ChainMaintenanceHandlingFeeModalComponent implements OnInit {
  @Input() mode;

  public isDisabled;
  loading = {
    submit: false
  };
  recipientSelectorLabel = "LABEL_RECIPIENT"
  companyRequired = true;
 
  constructor(
    private fb: FormBuilder,
    public helper: HelperService,
    public media: MediaObserver,
    private dialogService: DialogService,
    public languageService: LanguageService,
    private chainMntSvc: ChainMaintenanceService,
    public dialogRef: MatDialogRef<ChainMaintenanceHandlingFeeModalComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {}
 
  public formGroup: FormGroup;
 
  ngOnInit() {
    this.initForm();
    console.log(this.data)
  }
 
  initForm() {
    this.formGroup = this.fb.group({
      company: _.get(this, "data"),
 
      handling_fee: [_.get(this.data, "handling_fee_value"), [Validators.required, Validators.max(100), this.helper.decimalTwoPlaces]],

      status: _.get(this.data, "is_active") == 1 ? true : false
    });
 
    this.toggleDisable();
  }
 
  toggleDisable() {
    if (!this.data.id) {
      this.formGroup.get("status").disable({ emitEvent: false });
      this.formGroup.get("status").setValue(true);
      this.isDisabled = false;
    } else {
      this.formGroup.get("company").disable({ emitEvent: false });
      this.isDisabled = true;
    }
  }
 
  companySelected(ev) {
    this.formGroup.get('company').setValue(ev);
    this.formGroup.get('company').markAsTouched();
  }

  saveChanges() {
    let loadingDialog = this.dialogService.loading();
    this.formGroup.disable();

    let is_active = _.get(this.formGroup.get("status"), "value") ? 1 : 0;

    let obj = {
      data: [
        {
          id: _.get(this.data, "id") || 0,

          chain_id: _.get(this.data, "chain_id") || 0,
 
          company_id: _.get(this.formGroup.get("company"), "value.id") || 0,
 
          handling_fee_value: _.round(_.get(this.formGroup.get("handling_fee"), "value"), 2).toFixed(2),

          is_active: is_active
        }
      ]
    };

    this.chainMntSvc.insertHandlingFees(obj).pipe(
        finalize(() => {
          loadingDialog.close();
          this.formGroup.enable();
          this.toggleDisable();
        })
      )
      .subscribe(
        (res: any) => {
          if (environment.showLogs) {
            console.log(res);
          }

          if (_.has(res, 'status') && _.get(res, 'status') == 0) {
            this.helper.networkErrorMessage();
            return;
          }

          if(this.helper.displayErrorMessage(res)) return;

          if (_.get(res, 'success.count') > 0) {
            this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_DATA_UPDATED", {}));
            this.close(true);
          }
        },
        err => {
          console.log(err);
        }
      );
  }
 
  disableSaveBtn() {
    return this.loading.submit || (this.formGroup.touched && !this.formGroup.valid)
  }

  close(data) {
    this.dialogRef.close(data);
  }
}